import { WorkflowError } from '../engine/workflowEngine'

/**
 * Kolom yang tidak boleh diubah lewat `PATCH /items/<collection>` setelah baris dibuat (padanan izin field Directus:
 * create-only). `material_request.staging_zone_id`: Area Staging Produksi tidak bisa diubah setelah request dikirim —
 * tidak ada fitur batal, salah area berarti request baru (v7.50 Q-03 / keputusan user 2026-10-20).
 */
export const IMMUTABLE_FIELDS: Record<string, string[]> = {
  material_request: ['staging_zone_id'],
  /** Keputusan user 2026-10-21 #8 (D82): kode material terkunci setelah dibuat (tercetak di QR / stiker). */
  mt_material: ['code']
}

/** Pesan per kolom terkunci. */
export const IMMUTABLE_MESSAGE: Record<string, string> = {
  'material_request.staging_zone_id':
    'Kolom staging_zone_id tidak bisa diubah setelah dikirim — buat request baru bila areanya salah.',
  'mt_material.code': 'Kode material terkunci setelah material dibuat — kode tercetak di QR dan stiker.'
}

export const immutableMessage = (collection: string, field: string) =>
  IMMUTABLE_MESSAGE[`${collection}.${field}`] ?? `Kolom ${field} tidak bisa diubah setelah dibuat.`

/** Nama kolom terlarang yang ada di `patch`, atau `null` bila patch aman. */
export function immutableFieldViolation(collection: string, patch: Record<string, unknown> | undefined) {
  if (!patch) return null
  return (IMMUTABLE_FIELDS[collection] ?? []).find(field => field in patch) ?? null
}

export function assertMutable(collection: string, patch: Record<string, unknown> | undefined) {
  const field = immutableFieldViolation(collection, patch)
  if (field) throw new WorkflowError(immutableMessage(collection, field), 'ERR_IMMUTABLE_FIELD', 403)
}
